export const parseJsonBuilderValue = (value: unknown) => {
  if (typeof value === "string") {
    try {
      return JSON.parse(value);
    } catch {
      return {};
    }
  }
  return value || {};
};

export const isEmptyJsonLike = (value: unknown) => {
  if (value == null) return true;
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === "object") return Object.keys(value).length === 0;
  return value === "";
};

export const shouldAcceptJsonBuilderChange = (
  next: unknown,
  current: unknown,
  modalMode?: string
) => {
  if (
    modalMode === "edit" &&
    !isEmptyJsonLike(current) &&
    isEmptyJsonLike(next)
  ) {
    return false; 
  }
  return JSON.stringify(next) !== JSON.stringify(current); 
};
